import styled, { css, keyframes } from 'styled-components';

const dcSpin = keyframes`
  to { transform: translate(-50%, -50%) rotate(360deg); }
`;

export const Root = styled.div`
  width: 100%;
`;

export const CardViewer = styled.div`
  width: 100%;
  height: 260px;
  position: relative;

  @media (max-width: 768px) {
    height: 240px;
  }
`;

export const LoadingSpinner = styled.div<{ $hidden?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  border: 2px solid rgba(0, 220, 255, 0.15);
  border-top-color: rgba(0, 220, 255, 0.7);
  border-radius: 50%;
  animation: ${dcSpin} 0.8s linear infinite;
  pointer-events: none;
  z-index: 1;
  transition: opacity 0.3s;
  ${({ $hidden }) => $hidden && 'opacity: 0;'}
`;

export const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
  display: block;
`;

export const CardName = styled.div`
  font-family: 'Rajdhani', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  color: #ff79c6;
  letter-spacing: 0.05em;
  margin-top: 10px;
  margin-bottom: 6px;
  text-shadow: 0 0 15px rgba(255, 121, 198, 0.3);

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const CardSpecs = styled.div`
  text-align: left;
  margin: 0 auto 0;
  padding: 0 12%;

  @media (max-width: 768px) {
    padding: 0 5%;
  }
`;

export const SpecRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
  font-family: 'Share Tech Mono', monospace;
  font-size: 0.78rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

export const SpecLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
`;

export const SpecVal = styled.span`
  color: #55fde9;
  text-align: right;
  white-space: nowrap;
`;

export const CardTokens = styled.div`
  text-align: left;
  margin: 0 auto 10px;
  padding: 6px 12% 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  @media (max-width: 768px) {
    padding: 6px 5% 0;
  }
`;

export const TokenRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 3px 0;
  font-family: 'Share Tech Mono', monospace;
  font-size: 0.78rem;

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

export const TokenLabel = styled.span`
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
`;

export const TokenVal = styled.span`
  color: #ff8c00;
  text-align: right;
  white-space: nowrap;
`;

const buyBtnBase = css`
  display: block;
  width: 76%;
  margin: 0 auto;
  padding: 10px 20px;
  border-radius: 6px;
  background: linear-gradient(135deg, rgba(155, 89, 182, 0.3), rgba(52, 152, 219, 0.3));
  border: 1px solid rgba(155, 89, 182, 0.5);
  color: #fff;
  font-family: 'Share Tech Mono', monospace;
  font-size: 0.85rem;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s;
  backdrop-filter: blur(10px);
  box-shadow: none;

  &:hover {
    background: linear-gradient(135deg, rgba(155, 89, 182, 0.5), rgba(52, 152, 219, 0.5));
    border-color: rgba(155, 89, 182, 0.8);
    box-shadow:
      0 0 20px rgba(155, 89, 182, 0.4),
      0 0 40px rgba(52, 152, 219, 0.2);
  }

  &:active {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 12px 20px;
    width: 90%;
  }
`;

export const BuyBtn = styled.button<{ $status?: string }>`
  ${buyBtnBase}

  ${({ $status }) =>
    $status === 'out-of-stock' &&
    css`
      background: rgba(100, 100, 100, 0.3);
      border-color: rgba(100, 100, 100, 0.4);
      color: rgba(255, 255, 255, 0.4);
      cursor: not-allowed;
      box-shadow: none;

      &:hover {
        background: rgba(100, 100, 100, 0.3);
        border-color: rgba(100, 100, 100, 0.4);
        box-shadow: none;
      }
    `}

  ${({ $status }) =>
    $status === 'preorder' &&
    css`
      background: linear-gradient(135deg, rgba(200, 150, 0, 0.3), rgba(180, 120, 0, 0.3));
      border-color: rgba(200, 150, 0, 0.5);
      color: #fff;
    `}
`;

export const CardStatus = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 4px;
  min-height: 16px;
`;
